module.exports = __webpack_public_path__ + "img/fs.681f8af9.png";